import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import "./styles/Footer.css";

function Footer() {
  return (
    <footer className="footer  py-5">
      <Container>
        <Row>
          {/* About Section */}
          <Col md={4} className="mb-4">
            <h5 className="">About Goatt</h5>
            <p>
              Goatt (Goat Teachers) is a student-first education technology
              platform. Which offers the <strong>Rating Network</strong> (rate
              university and faculty members), <strong>Tutor Network</strong>{" "}
              (find or be a tutor), and <strong>Resource Network</strong> (share
              and access study resources) — all driven by student powered by AI.
            </p>
          </Col>

          {/* Policies Section */}
          <Col md={4} className="mb-4">
            <h5>Policies</h5>
            <ul className="list-unstyled">
              <li>
                <a
                  href="https://goatteachers.com/siteguidelines"
                  className="footer-link"
                >
                  Site Guidelines
                </a>
              </li>
              <li>
                <a href="#terms" className="footer-link">
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a href="#privacy-policy" className="footer-link">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#copyright-compliance" className="footer-link">
                  Copyright Compliance
                </a>
              </li>
            </ul>
          </Col>

          {/* Social Media Section */}
          <Col md={4} className="mb-4 text-center">
            <h5>Follow Us</h5>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/goatteachers"
                className="social-icon"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook />
              </a>
              <a
                href="https://x.com/goatteachers"
                className="social-icon"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
              <a
                href="https://www.instagram.com/goatteachers/"
                className="social-icon"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com/company/g0att/"
                className="social-icon"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedin />
              </a>
            </div>
          </Col>

          {/* Contact Section */}

          <div>
            <h5>Contact</h5>
            <p>📧 support@goatteachers.com</p>
            <p className="mb-1">📞 +8801323719131</p>
          </div>
        </Row>

        <hr className="footer-divider" />
        <div className="text-center">
          <p className="mb-0">
            Made with ❤️ in Dhaka, Bangladesh. © 2024-2025 Goat Technologies
            Limited. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
